<template>
    <div class="vx-card p-8 pt-0 flex flex-col gap-4 w-1/3">
        <div class="flex flex-col gap-2">
            <div>
                <LabelForm>{{ $t('admin.mapbox-accounts.username') }}</LabelForm>
                <vs-input class="border-grey-light w-full"
                          type="text"
                          v-model="mapboxAccount.username"
                          :danger="mapboxAccount.username == ''"
                />
            </div>

            <div>
                <LabelForm>{{ $t('admin.mapbox-accounts.email') }}</LabelForm>
                <vs-input class="border-grey-light w-full"
                          type="text"
                          v-model="mapboxAccount.account_email"
                          :danger="mapboxAccount.account_email == ''"
                />
            </div>

            <div>
                <LabelForm>{{ $t('admin.mapbox-accounts.public_access_token') }}</LabelForm>
                <vs-input class="border-grey-light w-full"
                          type="password"
                          v-model="mapboxAccount.public_access_token"
                          :danger="mapboxAccount.public_access_token == ''"
                />
            </div>

            <div>
                <LabelForm>{{ $t('admin.mapbox-accounts.private_access_token') }}</LabelForm>
                <vs-input class="border-grey-light w-full"
                          type="password"
                          v-model="mapboxAccount.access_token"
                          :danger="mapboxAccount.access_token == ''"
                />
            </div>
        </div>

        <div class="flex items-center ml-0 gap-4 mt-5">
            <vs-button :disabled="!isValid" class="rounded-lg xs:w-full sm:w-auto" @click="save">
                {{ $t('resorts.touristic-objects.form.saveButton') }}
            </vs-button>
            <vs-button type="border" class="rounded-lg xs:w-full sm:w-auto text-primary" @click="$router.push({'name': 'admin-mapbox-accounts'})">
                {{ $t('resorts.touristic-objects.form.cancelButton') }}
            </vs-button>
        </div>
    </div>
</template>

<script>

import store from "@/modules/Shared/Store/store";
import loader from "@/modules/Shared/Mixins/loader";
import MapboxAccountsService from "@/modules/Admin/Services/MapboxAccountsService";
import LabelForm from "@/modules/Shared/Components/form/LabelForm.vue";

export default {
    name: "EditMapboxAccountPage",
    components: {LabelForm},
    mixins: [loader],
    data() {
        return {
            templatesComboboxPage: 1,
            templatesComboboxEnded: false,
            mapboxAccount: {
                uuid: "",
                username: "",
                account_email: "",
                access_token: "",
                public_access_token: "",
            },
            new: true,
        }
    },

    computed: {
        isValid() {
            return this.mapboxAccount.username &&
                this.mapboxAccount.account_email &&
                this.mapboxAccount.access_token &&
                this.mapboxAccount.public_access_token
        }
    },

    async beforeRouteEnter(to, from, next) {
        try {
            const mapboxAccount = await MapboxAccountsService.getMapboxAccount(to.params.uuid);
            await store.dispatch('setRouteElement', mapboxAccount)
            next(vm => {
                vm.mapboxAccount = mapboxAccount
                vm.new = false
            })
        } catch (error) {
            await store.dispatch('setRouteElement', null)
            next(vm => {
                vm.mapboxAccount = {
                    uuid: to.params.uuid,
                    username: "",
                    account_email: "",
                    access_token: "",
                    public_access_token: "",
                }
            })
        }
    },
    methods: {
        save() {
            this.loadAndNotify(async () => {
                if (this.new) {
                    await MapboxAccountsService.createMapboxAccount(this.$route.params.uuid, this.mapboxAccount);
                } else {
                    await MapboxAccountsService.updateMapboxAccount(this.mapboxAccount.uuid, this.mapboxAccount);
                }

                await this.$router.push({'name': 'admin-mapbox-accounts'});
            })
        },
    }
};
</script>
